import React, { Component } from 'react';

import { TableLayout } from '../Menu/Stock/containers/Layout';
import SearchBar from './Layouts/SeachBar';
import Dialog from '../../commonModules/interface/Dialog';

import NewAgent from '../Menu/module/paygoNewAgentDynamic.jsx' 
import AgentStats from './Agents/AgentStats';
import { isEmpty } from "lodash";
import NewZone from '../Menu/module/paygoNewZone';
import AgentOptions from './Agents/AgentOptions';
import CommercialPopUp from './Agents/CommercialPopUp';
import { Grid, Button, TableHead, TableBody, TableRow, Box, TableCell, IconButton } from '@material-ui/core';
import { FormatListBulletedRounded, BarChartRounded, MoreVertRounded, AddCircleOutlineRounded, PinDropRounded } from '@material-ui/icons';
import PageAdmin from './Layouts/PageAdmin';
import SearchBarAction from './Layouts/SearchBarAction';
import CardButton from '../../commonModules/interface/CardButton';

class AgentsList extends Component {
    state = { 
        new: false,
        suivi: false,
        openOptions: false,
        isRZ: false,
        list: [],
        details: false,
        current: "",
        openFormTypes: false,
     }
    componentDidMount = async  () => {
        const { AGENTS, STATE } = this.props;
        if( isEmpty(AGENTS) ){
            await this.props.fetchAgents()
        }
        this.filterList()
        if(!STATE.zones.fetching && !STATE.zones.fetched){
            this.props.getZoneList()
        }
        // if( isEmpty(this.props.COMMERCIAL_STOCKS) ){
        //     this.props.fetchCommercialStocks()
        // }
        // if( isEmpty(this.props.COMMERCIAL_REAS) ){
        //     await this.props.fetchCommercialReas()
        // }
        // if( isEmpty(this.props.COMMERCIAL_RETURNS) ){
        //     await this.props.fetchCommercialReturns()
        // }
        // if( isEmpty(this.props.SALES) ){
        //     await this.props.fetchSales()
        // }
    }
    openPopUp = async (agent) => {
        this.setState({
            details:true,
            current:agent.id
        })
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.AGENTS) ){
                list = Object.keys(this.props.AGENTS)
            } else {
                list = []
            }
        }
        this.setState({
            list
        })
    }
    render() {
        const { AGENTS } = this.props;
        const { details, current, openOptions} = this.state;
        // console.log("RENDER ==> AGENT LIST")
        // console.log(this.state)

        let actions = [
            {
                openAction:() => this.setState({ new: true }),
                icon:<AddCircleOutlineRounded color="primary"/>,
                title: "Commercial"
            },
            {
                openAction: () =>this.setState({ newZone: true }),
                icon: <PinDropRounded color="secondary" />,
                title: "Zone"
            },
        ]
            // <Button 
            //     variant="contained"
            //     startIcon={<AddCircleOutlineRounded />}
            //     color="primary"
            //     onClick={()=>
            //         this.setState({ new: true })
            //     }>Commercial</Button>
            //     <br/>
            // <Button 
            //     variant="contained"
            //     startIcon={<AddCircleOutlineRounded />}
            //     color="secondary"
            //     onClick={()=>
            //         this.setState({ newZone: true })
            //     }>Zone</Button>
        return (
            <PageAdmin title="Agents Commerciaux">
                {this.state.new &&
                    <NewAgent 
                        {...this.props}
                        popupState={"overlay"} 
                        onCloseOverlay={ ()=> this.setState({ new: false }) }
                        onUpdate={() => {
                            console.log("Update Agent List");
                            this.props.fetchAgents()}
                        }
                    />
                    }
                {this.state.newZone &&
                    <NewZone 
                        {...this.props}
                        onClose={() => this.setState({ newZone: false }) }
                        onUpdate={() => {
                            console.log("Update ZONE");
                            this.props.getZoneList()
                        }}
                    />
                }
                {( details && current ) &&
                    <CommercialPopUp
                        closePopUp={() => this.setState({
                            details: false,
                            current: ""
                        })} 
                        commercial={AGENTS[current]}
                        STOCK_INFO_LIST
                        updateAgent={this.props.updateAgent}
                        // fetchProducts={this.props.fetchProducts}
                        // fetchCommercialStocks={this.props.fetchCommercialStocks}
                        // fetchCommercialReturns={this.props.fetchCommercialReturns}
                        // fetchCommercialReas={this.props.fetchCommercialReas}
                        {...this.props}
                    />
                    
                }
                {this.state.openFormTypes &&
                    <Dialog
                        title="Nouveau"
                        block={true}
                        close={() => this.setState({ 
                            openFormTypes: false,
                        }) }
                    >
                        {actions.map(action =>
                            <CardButton
                                action={action.openAction}
                                icon={action.icon}
                                title={action.title}
                            />
                        )}
                    </Dialog>
                }

                {( openOptions && current ) &&
                    // <Dialog 
                    //     title="Options"
                    //     block={openOptions}
                    //     close={()=> this.setState({openOptions:false, current:""}) }
                    // >
                        <AgentOptions 
                            isRZ={this.state.isRZ} 
                            listAgent={AGENTS} 
                            userID={this.state.current} 
                            close={()=> { 
                                this.props.fetchAgents();
                                this.setState({openOptions:false, current:""})}
                            }
                        /> 
                    // </Dialog>
                }
                {/* <h3>Agents Commerciaux</h3> */}
               
                <SearchBarAction list={ AGENTS } filterList={this.filterList} action={() => this.setState({ openFormTypes : true}) }/>
                {this.state.suivi ? (
                    <div>
                        <div className="text-right">
                            <Button 
                                variant="contained" 
                                title="Liste des Commerciaux"
                                onClick={()=>
                                    this.setState({ suivi: false })
                                }>
                                {/* <i className="zmdi zmdi-format-list-bulleted"></i> */}
                                <FormatListBulletedRounded />
                            </Button>                        
                        </div>
                        <AgentStats {...this.state} {...this.props}/>
                    </div>
                ) : (
                    <div>
                        {/* <div className="text-right">
                            <Button 
                                variant="contained" 
                                title="Suivi Performance"
                                onClick={()=>
                                    this.setState({ suivi: true })
                                }>
                                <BarChartRounded />
                            </Button>                        
                        </div> */}
                        <TableLayout>
                        {/* height={"690px"} */}
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th">ID</TableCell>
                                    <TableCell component="th">Name</TableCell>
                                    <TableCell component="th">Phone</TableCell>
                                    <TableCell component="th">Email</TableCell>
                                    <TableCell component="th">Zone</TableCell>
                                    <TableCell component="th">Entreprise</TableCell>
                                    <TableCell component="th">Options</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {AGENTS && this.state.list.map( ID => {
                                    let agent = AGENTS[ID]
                                    let colorLine = {}
                                    if (agent.isRZ) {
                                        colorLine = {color:"red"}
                                    }
                                    return(
                                        <TableRow key={agent.id} style={colorLine}>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.externalid}</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.name}</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{
                                                (Array.isArray(agent.phone) ? 
                                                agent.phone[0] : 
                                                agent.phone) 
                                                // (Array.isArray(agent.phone) ? 
                                                // agent.phone.join("\r\n") : 
                                                // agent.phone) 
                                                }</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.email}</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.zone}</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.company}</TableCell>
                                            <TableCell>
                                                <IconButton 
                                                    onClick={()=> this.setState({openOptions: true, current: ID,isRZ:agent.isRZ}) }
                                                >
                                                    {/* <i className="zmdi zmdi-more-vert"></i> */}
                                                    <MoreVertRounded />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )
                                } )
                            }
                            </TableBody>
                        </TableLayout>
                    </div>
                )}
                        
            </PageAdmin>
        );
    }
}

export default AgentsList